import { gql } from "@apollo/client";

// Subscripción que se activa cuando se recibe un nuevo mensaje de la ETD
export const OnLastETDData = gql`
    subscription OnLastETDData($etd_id: Int!) {
        its_weather_station_statuses(
            order_by: {created_at: desc}, 
            limit: 1, 
            where: {
                etd_id: {_eq: $etd_id}
            }
        ) {
            id
            No_detector: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.2.1.3.1\\\"]")
            Estado: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.5.0\\\"]")
            Congestion: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.6.0\\\"]")
            Sent_contrario: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.1.13.3.0\\\"]")
            Sent_circulacion: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.1.7.4.0\\\"]")
            Longitud: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.4.8.1.6.1\\\"]")
            Distancia: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.4.8.1.7.1\\\"]")
            Intensidad: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.4.0\\\"]")
            Ocupacion: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.4.0\\\"]")
            Velocidad: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.4.0\\\"]")
            Error_relativo: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.4.0\\\"]")
            longitud_1: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.4.0\\\"]")
            longitud_2: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.4.0\\\"]")
            longitud_3: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.4.0\\\"]")
            longitud_4: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.4.0\\\"]")
            velocidad_1: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.4.0\\\"]")
            velocidad_2: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.4.0\\\"]")
            velocidad_3: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.4.0\\\"]")
            created_at
            is_online
        }
    }
`;

// Subscripción que obtiene el último registro de cada ETD
export const OnAllETDLastData = gql`
    subscription OnAllETDLastData {
        its_weather_station_statuses(
            order_by: [
                {etd_id: asc},
                {created_at: desc}
            ],
            distinct_on: etd_id
        ) {
            id
            etd_id
            No_detector: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.2.1.3.1\\\"]")
            Estado: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.5.0\\\"]")
            Congestion: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.6.0\\\"]")
            Sent_contrario: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.1.13.3.0\\\"]")
            Sent_circulacion: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.1.7.4.0\\\"]")
            Longitud: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.4.8.1.6.1\\\"]")
            Distancia: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.4.8.1.7.1\\\"]")
            Intensidad: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.4.0\\\"]")
            Ocupacion: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.4.0\\\"]")
            Velocidad: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.4.0\\\"]")
            Error_relativo: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.4.0\\\"]")
            longitud_1: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.4.0\\\"]")
            longitud_2: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.4.0\\\"]")
            longitud_3: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.4.0\\\"]")
            longitud_4: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.4.0\\\"]")
            velocidad_1: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.4.0\\\"]")
            velocidad_2: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.4.0\\\"]")
            velocidad_3: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.4.0\\\"]")
            created_at
            is_online
        }
    }
`; 